import React from 'react';

export default function SearchResults({ data, onClose }) {
    const { merchants = [], receivers = [], donations = [] } = data || {};
    const Empty = () => <div className="p-6 text-sm text-slate-500">No results.</div>;

    return (
        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="flex items-center justify-between border-b border-slate-100 p-3">
                <div className="font-semibold text-sm">Search Results</div>
                <button onClick={onClose} className="rounded-lg px-2 py-1 text-sm border hover:bg-slate-50">Close</button>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 p-4">
                <div>
                    <div className="text-xs uppercase text-slate-500 mb-2">Merchants</div>
                    {merchants.length === 0 ? <Empty /> :
                        <ul className="space-y-1">{merchants.map(m => (
                            <li key={m._id} className="rounded-lg border p-2">
                                <div className="font-medium">{m.name}</div>
                                <div className="text-xs text-slate-500">{m.phone} • {m.email}</div>
                                <div className="text-xs text-slate-500">{m.address}</div>
                            </li>
                        ))}</ul>}
                </div>
                <div>
                    <div className="text-xs uppercase text-slate-500 mb-2">Receivers</div>
                    {receivers.length === 0 ? <Empty /> :
                        <ul className="space-y-1">{receivers.map(r => (
                            <li key={r._id} className="rounded-lg border p-2">
                                <div className="font-medium">{r.name}</div>
                                <div className="text-xs text-slate-500">{r.phone}{r.distanceKm ? ` • ${r.distanceKm} km` : ''}</div>
                            </li>
                        ))}</ul>}
                </div>
                <div>
                    <div className="text-xs uppercase text-slate-500 mb-2">Donations</div>
                    {donations.length === 0 ? <Empty /> :
                        <ul className="space-y-1">{donations.map(d => (
                            <li key={d._id} className="rounded-lg border p-2">
                                <div className="font-medium">{d._id}</div>
                                <div className="text-xs text-slate-500">
                                    {typeof d.merchant === 'object' ? d.merchant?.name : d.merchant} • {d.status}
                                </div>
                            </li>
                        ))}</ul>}
                </div>
            </div>
        </div>
    );
}
